import API from '@/api'
import { capitalize } from '@/utils/helpers'

const actions = {
  getDictionary({ commit }, { params, config }) {
    API.dictionaries[`get${capitalize(config.dictionaryName)}`](params)
      .then(({ data: { data: { results } } }) => {
        commit('setDictionary', { results, config })
      })
      .catch(({ data: { errors } }) => {
        commit('setDictionary', { results: [], config })
      })
  },
}

export default actions